import { useMedia } from 'react-use';

import { MOBILE_BREAKPOINT } from './constants';

interface IsMobileReturnType {
  isMobile: boolean;
}

export function useIsMobile(): IsMobileReturnType {
  const isMobile = useMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
  return { isMobile };
}
